import { ResultSourceEnum, MeasurementResultTypeEnum, VitalEnumType } from '../../../uc-api-sdk';

export type VitalType = MeasurementResultTypeEnum | VitalEnumType;

export class VitalHelper {
  public static getResultSource(resultSource?: ResultSourceEnum | null) {
    return resultSource === ResultSourceEnum.VISIT ? 'visit' : 'vital';
  }
}
